import React, { useState, useEffect } from 'react';
import UserTab from '../component/c-usermanagement/user-manage-tab';
import { useHistory } from 'react-router-dom';  // Use useNavigate instead of useHistory
import { getAllUsers } from '../api/apiService';
import { loader } from '../Actions/index';
import { useDispatch } from 'react-redux';
import TabletMacIcon from '@material-ui/icons/TabletMac';

const UserManagement = () => {
    const history = useHistory();  // Replacing useHistory with useNavigate
    const [userData, setUserData] = useState();
    const [type, setType] = useState("user");
    const [userCount, setUserCount] = useState({
        user: 0,
        owner: 0,
        manager: 0,
        appUserCount: 0,
        adminCount: 0,
    });
    const dispatch = useDispatch();

    const allUserType = (t) => {
        setType(t);
        allUser(t, 1);
    };
    
    const handleUserPage = (m) => {
        allUser(type, m.selected + 1);
    };

    useEffect(() => {
        allUser(type, 1);
    }, []);

    const allUser = async (userType, pageNo) => {
        dispatch(loader(true));
        try {
            const response = await getAllUsers(userType, pageNo);
            setUserData(response.data);
            setUserCount(response.data.userCount);
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(loader(false));
        }
    };

    return (
        <>
            <div className="mt-4 d-sm-flex justify-content-between">
                <div className="d-flex align-items-center justify-content-between notifi-box cursor-pointer"
                style={{background:'blue'}}
                    onClick={() => history.push('/users-management/add-user')}
                >
                    <div>
                        <div className="icon-container icon-1"><i className="demo-icon icon-add font-20" style={{color:'blue'}}>&#xe802;</i></div>
                    </div>
                    <div className="text-center" >
                        <div className="title" style={{color:'#fff'}}>Add</div>
                        <div className="sub-title" style={{color:'#fff'}}>New User</div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#ece2ff"}}>
                    <div>
                        <i className="demo-icon icon-user font-25" style={{color: "#bb9bf7" }}>&#xe821;</i>
                    </div>
                    <div className="text-center" >
                        <div className="title">{userCount.user}</div>
                        <div className="sub-title">Total User</div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#bcf1ed"}}>
                    <div>
                        <TabletMacIcon className="demo-icon font-25" style={{color: "#3ee4ff" }}/>
                    </div>
                    <div className="text-center">
                        <div className="title">{userCount.appUserCount}</div>
                        <div className="sub-title">App User</div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#e1f3a3"}}>
                    <div>
                        <i className="demo-icon icon-owner font-25" style={{color: "#8edd89" }}>&#xe820;</i>
                    </div>
                    <div className="text-center">
                        <div className="title">{userCount.owner}</div>
                        <div className="sub-title">Owner</div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-between notifi-box" style={{ background: "#ccfad6"}}>
                    <div>
                        <i className="demo-icon icon-manager font-25" style={{color: "#8edd89" }}>&#xe814;</i>
                    </div>
                    <div className="text-center">
                        <div className="title">{userCount.adminCount}</div>
                        <div className="sub-title">Super admin</div>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                {!userData ? "" : 
                <UserTab 
                data={userData} 
                allUserType = {allUserType}
                userPageFunc={handleUserPage} 

                />}
            </div>
            {/* <!-- The Modal One--> */}
            <div className="modal" id="myModal">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h4 className="modal-title">Assign Manager</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body d-flex justify-content-between">
                            <div className="form-group w-50 px-2">
                                <select className="form-control mb-3" id="sel1">
                                    <option>Add New Outlet</option>
                                    <option>Ipsum elit diam</option>
                                    <option>Praesent fringilla</option>
                                    <option>Vivamus proin</option>
                                </select>
                                <button type="button" className="btn bg-btn-color px-4 py-2 text-white float-right">Assign</button>
                            </div>
                            <div className="form-group w-50 px-2">
                                <select className="form-control mb-3" id="sel1">
                                    <option>Add New Manager</option>
                                    <option>Ipsum sodales ultricies</option>
                                    <option>Augue bibendum</option>
                                    <option>Quis rhoncus</option>
                                </select>
                                <button type="button" className="btn bg-btn-lightgray px-4 py-2" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- The Modal Two--> */}
            <div className="modal" id="myModal-2">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h4 className="modal-title">Assign Owner & Outlet</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body d-flex justify-content-between">
                            <div className="form-group w-50 px-2">
                                <select className="form-control mb-3" id="sel1">
                                    <option>Add New Owner</option>
                                    <option>Purus dapibus est</option>
                                    <option>PDictum tristique eros</option>
                                    <option>Vulputate nunc est</option>
                                </select>
                                <button type="button" className="btn bg-btn-color px-4 py-2 text-white float-right">Assign</button>
                            </div>
                            <div className="form-group w-50 px-2">
                                <select className="form-control mb-3" id="sel1">
                                    <option>Add New Outlet</option>
                                    <option>Ipsum elit diam</option>
                                    <option>Praesent fringilla</option>
                                    <option>Vivamus proin</option>
                                </select>
                                <button type="button" className="btn bg-btn-lightgray px-4 py-2" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserManagement;